import type { TrackingService } from '../feature-service-types';

export interface Tracking {
  sendReadyEvent(): void;
  sendImpressionEvent(): void;
  sendClickEvent(): void;
}

export function initTracking(
  attributes?: {
    version?: string;
    implementer?: number;
    [key: string]: unknown;
  },
  trackingService?: TrackingService,
): Tracking {
  const componentNameWithDashes = 'social-media-forwarding-notice';
  const componentNameWithSpaces = componentNameWithDashes.replace(/-/g, ' ');
  const defaultComponentAdditions = {
    componentInfo: {
      // not accepted by tracking lib
      // componentID: 'bla',
    },
    attributes: {
      version: __FEATURE_APP_VERSION__,
      ...attributes,
    },
  };

  return {
    sendReadyEvent: () => {
      if (trackingService) {
        const readyEvent = {
          event: {
            attributes: {
              componentName: componentNameWithDashes,
              elementName: '',
              label: '',
              clickID: '',
              pos: '',
              targetURL: '',
              value: '',
            },
            eventInfo: {
              eventAction: 'feature_app_ready',
              eventName: `${componentNameWithSpaces} - feature app ready`,
            },
          },
          componentUpdate: defaultComponentAdditions,
        };
        trackingService.track(readyEvent);
      }
    },
    sendImpressionEvent: () => {
      if (trackingService) {
        const impressionEvent = {
          event: {
            attributes: {
              componentName: componentNameWithDashes,
              elementName: '',
              label: '',
              clickID: '',
              pos: '',
              targetURL: '',
              value: '',
            },
            eventInfo: {
              eventAction: 'impression',
              eventName: `${componentNameWithSpaces} - impression`,
            },
          },
          componentUpdate: defaultComponentAdditions,
        };
        trackingService.track(impressionEvent);
      }
    },
    sendClickEvent: () => {
      if (trackingService) {
        const clickEvent = {
          event: {
            attributes: {
              componentName: componentNameWithDashes,
              elementName: 'other',
              label: '',
              clickID: '',
              pos: '',
              targetURL: '',
              value: '',
            },
            eventInfo: {
              eventAction: 'content',
              eventName: `${componentNameWithSpaces} - close notification`,
            },
          },
          componentUpdate: defaultComponentAdditions,
        };
        trackingService.track(clickEvent);
      }
    },
  };
}
